/**
 * External dependencies
 */
import React from 'react';

/**
 * Internal dependencies
 */

/**
 * Style dependencies
 */
import './styles.scss';

const JumpingDots = () => {
    return <span class="jumping-dots">
        <span class="dot-1">.</span>
        <span class="dot-2">.</span>
        <span class="dot-3">.</span>
    </span>;
}



export default JumpingDots;
    